import { useState } from 'react'
import { QRCodeSVG } from 'qrcode.react'
import { Download, Wifi } from 'lucide-react'
import Card from '../components/Card'
import Button from '../components/Button'

export default function WiFiQRGenerator() {
  const [ssid, setSsid] = useState('')
  const [password, setPassword] = useState('')
  const [security, setSecurity] = useState('WPA')
  const [hidden, setHidden] = useState(false)
  const [qrValue, setQrValue] = useState('')

  const generateWiFiQR = () => {
    if (!ssid.trim()) {
      alert('Please enter WiFi network name (SSID)')
      return
    }

    // WiFi QR code format: WIFI:T:WPA;S:NetworkName;P:Password;H:true;;
    const hiddenStr = hidden ? 'true' : 'false'
    const wifiString = `WIFI:T:${security};S:${ssid};P:${password};H:${hiddenStr};;`
    setQrValue(wifiString)
  }

  const downloadQR = () => {
    const svg = document.getElementById('wifi-qr-svg')
    if (!svg) return

    const svgData = new XMLSerializer().serializeToString(svg)
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    const img = new Image()

    img.onload = () => {
      canvas.width = 300
      canvas.height = 300
      ctx.drawImage(img, 0, 0)
      canvas.toBlob((blob) => {
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `wifi-${ssid}.png`
        link.click()
        URL.revokeObjectURL(url)
      })
    }

    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)))
  }

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="space-y-6">
            <div>
              <label className="block text-gray-700 font-semibold mb-3">WiFi Network Name (SSID):</label>
              <input
                type="text"
                value={ssid}
                onChange={(e) => setSsid(e.target.value)}
                className="input w-full"
                placeholder="Enter WiFi network name"
              />
            </div>

            <div>
              <label className="block text-gray-700 font-semibold mb-3">Password:</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input w-full"
                placeholder="Enter WiFi password (optional for open networks)"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-700 font-semibold mb-3">Security Type:</label>
                <select
                  value={security}
                  onChange={(e) => setSecurity(e.target.value)}
                  className="input w-full"
                >
                  <option value="WPA">WPA/WPA2</option>
                  <option value="WEP">WEP</option>
                  <option value="nopass">No Password (Open)</option>
                </select>
              </div>

              <div>
                <label className="block text-gray-700 font-semibold mb-3">Network Type:</label>
                <div className="flex items-center gap-3 mt-2">
                  <input
                    type="checkbox"
                    id="hidden"
                    checked={hidden}
                    onChange={(e) => setHidden(e.target.checked)}
                    className="w-4 h-4"
                  />
                  <label htmlFor="hidden" className="text-gray-700">
                    Hidden Network
                  </label>
                </div>
              </div>
            </div>

            <Button onClick={generateWiFiQR} variant="primary" className="w-full">
              <Wifi className="w-5 h-5 mr-2" />
              Generate WiFi QR Code
            </Button>
          </div>
        </Card.Body>
      </Card>

      {qrValue && (
        <Card>
          <Card.Body>
            <div className="text-center space-y-4">
              <div className="flex justify-center">
                <QRCodeSVG
                  id="wifi-qr-svg"
                  value={qrValue}
                  size={300}
                  level="M"
                  includeMargin={true}
                />
              </div>
              <div className="p-4 bg-blue-50 rounded-lg">
                <p className="text-sm text-gray-700 mb-1">
                  <strong>Network:</strong> {ssid}
                </p>
                <p className="text-sm text-gray-700">
                  <strong>Security:</strong> {security === 'nopass' ? 'Open Network' : security}
                </p>
              </div>
              <Button onClick={downloadQR} variant="primary" size="lg" className="w-full">
                <Download className="w-5 h-5 mr-2" />
                Download WiFi QR Code
              </Button>
            </div>
          </Card.Body>
        </Card>
      )}

      {!qrValue && (
        <Card>
          <Card.Body className="text-center py-12">
            <p className="text-gray-600">Enter WiFi network details and click "Generate WiFi QR Code"</p>
          </Card.Body>
        </Card>
      )}
    </div>
  )
}

